var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1407 6.68943H7.09443C7.72458 6.68943 8.23529 6.19033 8.23529 5.57452C8.23529 5.44509 8.2123 5.3167 8.1672 5.19511L7.08266 2.26482C6.70207 0.926416 5.45514 0.000174204 4.03369 0C2.55056 0 1.26637 1.00672 0.944613 2.42161L0.0509929 5.24597C-0.134755 5.83443 0.202871 6.45843 0.805035 6.63995C0.913774 6.6727 1.02697 6.68943 1.14088 6.68943H1.1407Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29382 7.43277C2.50274 8.43845 3.50653 9.08823 4.53563 8.88406C5.28397 8.73564 5.86866 8.16408 6.02072 7.43277H2.29382Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacion);
export default __webpack_public_path__ + "static/media/notificacion.fc0258359665fd13f4590e90d2462327.svg";
export { ForwardRef as ReactComponent };